import axiosClient from './axiosClient';

const adminVehicleTypeService = {
    getAll: async () => {
        const response = await axiosClient.get('/admin/vehicle-types');
        return response.data;
    },
    getById: async (id) => {
        const response = await axiosClient.get(`/admin/vehicle-types/${id}`);
        return response.data;
    },
    create: async (payload) => {
        const response = await axiosClient.post('/admin/vehicle-types', payload);
        return response.data;
    },
    update: async ({ id, payload }) => {
        const response = await axiosClient.put(`/admin/vehicle-types/${id}`, payload);
        return response.data;
    },
    delete: async (id) => {
        const response = await axiosClient.delete(`/admin/vehicle-types/${id}`);
        return response.data;
    }
};

export default adminVehicleTypeService;
